var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.formData),function(item){return _c('div',{key:item.index,staticClass:"form-item"},[_c('div',{staticStyle:{"flex":"1"}},[_vm._v(" "+_vm._s(item.label)+" ")]),_c('div',[_vm._v(":")]),_c('div',[_c('Comp',{key:item.id,attrs:{"data":item}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }